import {
  SkeletonLoader,
  SkeletonLoaderArea,
} from '@design/components/skeleton-loader/SkeletonLoader';
import { CatalystMarketReactionChart } from '@terminal/modules/market-reaction-charts/catalyst-market-reaction-chart/CatalystMarketReactionChart';
import { LineData } from '@terminal/modules/market-reaction-charts/types';
import React from 'react';

import styles from './MarketCatalystReaction.module.scss';

const skeletonLoaderAreas: SkeletonLoaderArea[] = [
  {
    styles: {
      width: '100%',
      height: '400px',
      borderRadius: '8px',
    },
  },
];

export interface MarketCatalystReactionChartViewProps {
  isLoading: boolean;
  fromDateEST?: Date;
  toDateEST?: Date;
  lines: LineData[];
  leftHeaderNode?: React.ReactNode;
  isDailyFallback?: boolean;
}

export const MarketCatalystReactionChartView = ({
  isLoading,
  fromDateEST,
  toDateEST,
  lines,
  leftHeaderNode,
  isDailyFallback,
}: MarketCatalystReactionChartViewProps) => {
  if (isLoading) {
    return (
      <div className={styles.skeletonLoaderWrapper}>
        <SkeletonLoader areas={skeletonLoaderAreas} />
      </div>
    );
  }

  return (
    <CatalystMarketReactionChart
      fromDateEST={fromDateEST}
      toDateEST={toDateEST}
      lines={lines}
      leftHeaderNode={leftHeaderNode}
      isDailyFallback={isDailyFallback}
    />
  );
};
